module.exports = __webpack_public_path__ + "static/img/10.42441aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/10.png
// module id = f7gR
// module chunks = 0